module.exports = __webpack_public_path__ + "static/media/Due.f44caa83.svg";